import React, { useState, useEffect } from "react";
import { Table, Tbody, TableContainer, Box, Divider, AbsoluteCenter, Text, Icon, Flex } from "@chakra-ui/react";
import { FiInfo } from 'react-icons/fi';

import { getUniqueVariables } from "../../utils/helpers";
import useDatasetsMetadata from "../../components/customHooks/useDatasetsMetadata";
import useObservationData from "../../components/customHooks/useObservationData";
import { TIDE_PARAMETER } from "../../utils/constants";
import { StationRow } from "./StationRow";
import ParameterSelect from "../../components/ParameterSelect";
import { RegionFilterDrawer } from "../../components/regionFilterDrawer/RegionFilterDrawer";
import { SelectedRegionBar } from "../../components/regionFilterDrawer/SelectedRegionBar";
import useRegions from "../../components/customHooks/useRegions";

export const ParametersIndex = () => {
    const [selectedParameter, setSelectedParameter] = useState('');
    const [stations, setStations] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState([]);

    const datasetsMetadata = useDatasetsMetadata();
    const observationData = useObservationData();
    const regions = useRegions();

    const parameters = getUniqueVariables(datasetsMetadata.data);

    useEffect(() => {
        // Any stations which have TIDE_PARAMETER are considered Tidal Buoys, all others "regular" stations
        if (observationData.data?.length > 0) {
            const filteredStations = observationData.data.filter(station => {
                    return station?.obsData?.some(observation => {
                        return !observation.hasOwnProperty(TIDE_PARAMETER);
                    });
                })
                .filter((station) => {
                    if (selectedRegions?.length > 0) {
                        return selectedRegions.includes(station?.regionID);
                    } else {
                        return true;
                    }
                })


            setStations(filteredStations);
        }
    }, [observationData.data, selectedRegions]);

    return (
        <Box bg='white'>
            <Box px={4}>
                <Flex justifyContent={'space-between'} alignItems={'center'} my={5}>
                    <Text fontSize={'20px'} fontWeight={'bold'}>Parameters</Text>
                    <RegionFilterDrawer regions={regions.data?.regions} selectedRegions={selectedRegions} setSelectedRegions={setSelectedRegions} />
                </Flex>
                <SelectedRegionBar regions={regions.data?.regions} selectedRegions={selectedRegions} setSelectedRegions={setSelectedRegions} />
                <ParameterSelect parameters={parameters} selectedParameter={selectedParameter} setSelectedParameter={setSelectedParameter} />
                <Box position='relative' paddingTop='10' paddingBottom='10'>
                    <Divider />
                    <AbsoluteCenter bg='white' px={4} textColor={'gray.400'} marginBottom={20} minWidth={200} textAlign='center'>Parameter by Station</AbsoluteCenter>
                </Box>
            </Box>
            {selectedParameter && (
                <TableContainer px={4}>
                    <Table variant="simple">
                        <Tbody>
                            {stations.map((station, index) => (
                                <StationRow
                                    key={index} 
                                    station={station}
                                    datasetsMetadata={datasetsMetadata.data}
                                    parameter={selectedParameter}
                                />
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            )}
            {!selectedParameter && (
                <Box p={4} mt={4} pb={10} textAlign='center'>
                    <Icon as={FiInfo} boxSize={'24px'} color='gray.500' />
                    <Text color='gray.500' fontWeight={600} fontSize={20}>No Parameter Selected</Text>
                    <Text color='gray.500' fontSize={14}>Select a parameter to view the latest station data</Text>
                </Box>
            )}
        </Box>
    );
};
